/**
 * userConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

/**
 * Constants used by user actions
 */
const userConstants = {

  USER_TOKEN_READY: "USER_TOKEN_READY",
  USER_TOKEN_NOT_READY: "USER_TOKEN_NOT_READY",
  SET_TOKEN_REFRESH_RETRY_COUNT: "SET_TOKEN_REFRESH_RETRY_COUNT",
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  IMPERSONATE_LOGIN_SUCCESS: "IMPERSONATE_LOGIN_SUCCESS",

  TOKEN_REFRESHED: "TOKEN_REFRESHED",
  SET_ACCESS_TOKEN_IS_VALID: "SET_ACCESS_TOKEN_IS_VALID",
  CLEAR_AUTH_ERROR: "CLEAR_AUTH_ERROR",
  REFRESH_TOKEN_PENDING: "REFRESH_TOKEN_PENDING",
  UPDATE_REFRESH_TOKEN_STATUS: "UPDATE_REFRESH_TOKEN_STATUS",
  LOGOUT: "USERS_LOGOUT",
  RESET_STORE_EXCEPT_IMPERSONATE_USER_ID: "RESET_STORE_EXCEPT_IMPERSONATE_USER_ID",
  SET_MOXTRA_ACCESS_TOKEN: "SET_MOXTRA_ACCESS_TOKEN",
  GET_USER_PERMISSIONS: "GET_USER_PERMISSIONS",
  GET_USER_PERMISSIONS_PENDING: "GET_USER_PERMISSIONS_PENDING",
  SET_PERMITTED_FEATURES: "SET_PERMITTED_FEATURES",
  USER_NAME_LEN: 15,
  SET_USER_ROLE: "SET_USER_ROLE",
  SAVE_IMPERSONATE_USER_ID: "SAVE_IMPERSONATE_USER_ID",
  SET_CALL_HISTORY_LAST_VIEWED: "SET_CALL_HISTORY_LAST_VIEWED",
  permissions: {
    EDIT: "edit",
  },
};

export default userConstants;
